import { render, staticRenderFns } from "./TechnologyRating.vue?vue&type=template&id=4256b001&scoped=true"
import script from "./TechnologyRating.vue?vue&type=script&lang=js"
export * from "./TechnologyRating.vue?vue&type=script&lang=js"
import style0 from "./TechnologyRating.vue?vue&type=style&index=0&id=4256b001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4256b001",
  null
  
)

export default component.exports